import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';

export const emoticonsMap = [
  // 1. Happy / Smileys / Laugh
  { match: /(?:^|\s)(:-\)|:\))$/, replace: '😊' }, // :) or :-)
  { match: /(?:^|\s)(:-D|:D)$/, replace: '😀' }, // :D or :-D
  { match: /(?:^|\s)(XD|xD)$/, replace: '😆' }, // XD or xD
  { match: /(?:^|\s)(;-\)|;\))$/, replace: '😉' }, // ;) or ;-)
  { match: /(?:^|\s)(:-\*|:\*)$/, replace: '😘' }, // :* or :-*

  // 2. Sad / Cry / Upset
  { match: /(?:^|\s)(:-\(|:\()$/, replace: '🙁' }, // :( or :-(
  { match: /(?:^|\s)(:'-\(|:'\()$/, replace: '😢' }, // :'( or :'-(
  { match: /(?:^|\s)(>:-\(|>:\()$/, replace: '😠' }, // >:( or >:-(

  // 3. Surprised / Playful
  { match: /(?:^|\s)(:-O|:O|:-o|:o)$/, replace: '😮' }, // :O or :-O
  { match: /(?:^|\s)(:-P|:P|:-p|:p)$/, replace: '😛' }, // :P or :-P
  { match: /(?:^|\s)(;-P|;P|;-p|;p)$/, replace: '😜' }, // ;P or ;-P

  // 4. Cool, Neutral & Thinking
  { match: /(?:^|\s)(B-\)|8-\))$/, replace: '😎' }, // B-) or 8-)
  { match: /(?:^|\s)(:-\||:\|)$/, replace: '😐' }, // :| or :-|
  { match: /(?:^|\s)(:-\/|:\/|:-\\|:\\)$/, replace: '😕' }, // :/ or :\
  { match: /(?:^|\s)(-_-)$/, replace: '😑' }, // -_-

  // 5. Hearts & Love
  { match: /(?:^|\s)(<3)$/, replace: '❤️' }, // <3
  { match: /(?:^|\s)(<\/3)$/, replace: '💔' }, // </3

  // 6. Thumbs & Hand Gestures
  { match: /(?:^|\s)(\(y\)|\(Y\))$/, replace: '👍' }, // (y) or (Y)
  { match: /(?:^|\s)(\(n\)|\(N\))$/, replace: '👎' }, // (n) or (N)
  { match: /(?:^|\s)(\(ok\)|\(OK\))$/, replace: '👌' }, // (ok) or (OK)
  { match: /(?:^|\s)(\(clap\)|\(CLAP\))$/, replace: '👏' }, // (clap)
  { match: /(?:^|\s)(\(handshake\)|\(HANDSHAKE\))$/, replace: '🤝' }, // (handshake)
  { match: /(?:^|\s)(\(wave\)|\(WAVE\))$/, replace: '👋' }, // (wave)

  // 7. Everyday Work & Celebration
  { match: /(?:^|\s)(\(check\)|\(done\))$/, replace: '✅' }, // (check) or (done)
  { match: /(?:^|\s)(\(fire\))$/, replace: '🔥' }, // (fire)
  { match: /(?:^|\s)(\(party\))$/, replace: '🎉' }, // (party)
  { match: /(?:^|\s)(\(coffee\))$/, replace: '☕' }, // (coffee)
  { match: /(?:^|\s)(\(star\))$/, replace: '⭐' }, // (star)
  { match: /(?:^|\s)(\(100\))$/, replace: '💯' }, // (100)
  { match: /(?:^|\s)(\(eyes\))$/, replace: '👀' }, // (eyes)
];

export const EmoticonsExtension = Extension.create({
  name: 'emoticons',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('emoticonsDirectPlugin'),
        props: {
          handleTextInput(view, from, to, text) {
            const { state } = view;
            const $from = state.doc.resolve(from);
            const textBefore =
              $from.parent.textBetween(0, $from.parentOffset, null, '\ufffc') +
              text;

            for (const item of emoticonsMap) {
              const match = item.match.exec(textBefore);
              if (match) {
                const shortcut = match[1];
                const matchStart =
                  from -
                  (match[0].length - text.length) +
                  match[0].indexOf(shortcut);
                const matchEnd = to;

                const tr = state.tr.replaceWith(
                  matchStart,
                  matchEnd,
                  state.schema.text(item.replace)
                );

                view.dispatch(tr);
                return true;
              }
            }
            return false;
          },
        },
      }),
    ];
  },
});

export default EmoticonsExtension;
